@if (this.payMethodList!=null) {

<div class="pay-method-editor">
    @if (fintechService.editMode != "billing") {
        <label class="header-label"><mat-icon style="vertical-align: middle; margin-right: 8px;">credit_card</mat-icon>{{ 'ai.paymentMethod' | transloco }}:</label>
        <div class="horizontal-container">
            @if (showRecurringCard()) {
                <div class="vertical-container" style="width: 470px">
                    <div class="card-info-label">For Subscription:</div>
                    <app-fintech-pay-method-info #subscriptionPayMethod class="selected-pay-method-info" style="width: 400px">
                    </app-fintech-pay-method-info>
                    <button (click)="onReplaceCard('Subscription')" class="subButton" mat-raised-button [disabled]="fintechService.editMode!='info'"><mat-icon>sync</mat-icon>{{ 'ai.replaceCard' | transloco }}</button>
                </div>
            }
            @if (showPurchasesCard()) {
                <div class="vertical-container" style="width: 500px">
                    <div class="card-info-label">For Purchases:</div>
                    <app-fintech-pay-method-info #purchasesPayMethod class="selected-pay-method-info" style="width: 400px">
                    </app-fintech-pay-method-info>
                    <button (click)="onReplaceCard('Purchases')" class="subButton" mat-raised-button [disabled]="fintechService.editMode!='info'"><mat-icon>sync</mat-icon>{{ 'ai.replaceCard' | transloco }}</button>
                </div>
            }
        </div>
    }
    @if (fintechService.editMode == "billing") {
        <label class="header-label"><mat-icon style="vertical-align: middle; margin-right: 8px;">credit_card</mat-icon>{{selectionFor}} {{ 'ai.paymentMethod' | transloco }}:</label>
        <div class="horizontal-container" style="align-items: center; padding-top: 5px">
            <ngx-flicking #flk [options]=flickingOptions (ready)="onReady()" [ngStyle]="{'display': isFlickingVisible ? 'block' : 'none'}">
                <div flicking-panel *ngFor="let page of payMethodList" class="flicking-panel">
                    <div class="horizontal-container">
                        <div class="vertical-container">
                            @if (selectionFor == "Subscription") {
                                <mat-radio-group [(ngModel)]="recurringPayMethodId">
                                    <mat-radio-button [value]="page.payMethodId">{{ 'ai.selected' | transloco }}</mat-radio-button>
                                </mat-radio-group>
                            }
                            @if (selectionFor == "Purchases") {
                                <mat-radio-group [(ngModel)]="orderPayMethodId">
                                    <mat-radio-button [value]="page.payMethodId">{{ 'ai.selected' | transloco }}</mat-radio-button>
                                </mat-radio-group>
                            }
                        </div>
                        <button (click)="onPayMethodDelete(page.payMethodId)" class="subButton" mat-raised-button [disabled]="fintechService.busy"><mat-icon>delete</mat-icon>{{ 'ai.deleteCard' | transloco }}</button>
                    </div>
                    <app-fintech-pay-method-info  [payMethodInfo]="page" class="hand-cursor"></app-fintech-pay-method-info>
                </div>
            </ngx-flicking>


            <div class="vertical-container">
                <div class="add-button-container">
                    <button (click)="onAddPayMethod()" class="add-card-button" mat-raised-button [disabled]="fintechService.busy"><mat-icon>add_card</mat-icon>{{ 'general.add' | transloco }}</button>
                </div>
            </div>
        </div>
        <button (click)="onPayMethodUpdate()" class="subButton" mat-raised-button [disabled]="!canSelectPayMethod()"><mat-icon>check_circle</mat-icon>{{ 'general.yourSelection' | transloco }}</button>
        <button (click)="onPayMethodCancel()" class="subButton" mat-raised-button [disabled]="fintechService.busy"><mat-icon>close</mat-icon>{{ 'general.close' | transloco }}</button>
    }
</div>
}
